<template>
  <div class="conf-wrp">
    <div class="content-wrp">
      <div class="content">
        <el-form class="form" :model="value" :rules="rules" ref="form" label-width="20%">
          <section>
            <div class="title">
              <span>基础设置</span>
            </div>
            <div class="conf">
              <el-form-item label="店铺品牌设置：">
                <BrandSettingConfig
                    v-if="shopList.length"
                    ref="branchSettingConfig"
                    v-model="brandConfList"
                    :shopList="shopList"
                />
                <span class="no-shops" v-else>暂无平台店铺</span>
              </el-form-item>
              <el-form-item label="类目外品牌设置：">
                  <BrandSettingOtherConfig
                      v-if="shopList.length"
                      ref="branchSettingConfig"
                      v-model="dataSourceCategory"
                      :shopList="shopList"
                  />
                  <span class="no-shops" v-else>暂无平台店铺</span>
              </el-form-item>
            </div>
          </section>
          <section>
            <div class="title">
              <span>上架设置</span>
            </div>
            <div class="conf">
              <el-form-item label="上架设置:" prop="shelfState">
                <el-radio-group v-model="value.shelfState">
                  <el-radio :label="1">立即上架</el-radio>
                  <el-radio :label="2">放入仓库中</el-radio>
                  <!-- <el-radio :label="2">放入草稿箱</el-radio> -->
                </el-radio-group>
              </el-form-item>
            </div>
          </section>
          <section>
            <div class="title">
              <span>款式编码来源字段</span>
            </div>
            <div class="conf">
              <el-form-item label="款式编码来源字段：" prop="outerType">
                <el-radio-group v-model="value.outerType">
                  <el-radio :label="1">商品ID</el-radio>
                  <el-radio :label="2">货号或款号</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item>
                <span style="font-size: 12px">从小红书下载商品资料到基础资料时可以选择货号或款号作为平台资料商品的款式编码来源</span>
              </el-form-item>
            </div>
          </section>
          <section>
            <div class="title">
              <span>图片设置</span>
            </div>
            <div class="conf">
              <div style="padding-left:15%;">图片修正规则：按照平台比例和尺寸大小要求，修正成最优且符合要求的图片。若图片大小不符合平台要求，将自动压缩后重新上传，不支持压缩20M以上的图片。</div>
              <el-form-item prop="autoCropImageConfigList">
                <el-checkbox-group v-model="value.autoCropImageConfigList">
                  <el-checkbox label="mainImg">主图</el-checkbox>
                  <el-checkbox label="whiteImg">透明素材图</el-checkbox>
                  <el-checkbox label="skuImg">规格图</el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </div>
          </section>
          <section>
            <div class="title">
                <span>物流设置</span>
            </div>
            <div class="conf">
                <el-form-item label="物流模版:" prop="logisticsList" label-width="120px">
                    <div class="ship-wrp" v-if="shopList.length > 0">
                        <div class="item" v-for="(item, idx) in shopList" :key="idx">
                            <div class="shopname">
                                <img class="shop-img" :src="item.icon"/>
                                <el-tooltip v-if="item.channelIcon" :content="item.channelName" style="margin: 0px -6px 0px 6px;">
                                    <el-image :src="item.channelIcon" style="width: 18px; height: 18px;overflow: unset;top: 4px;"></el-image>
                                </el-tooltip>
                                <span>{{ item.shortTitle || item.title }}</span>
                            </div>
                            <el-select 
                                :loading="selectLoading" 
                                v-model="shipsValue[item.id]" 
                                placeholder="请选择物流模版" 
                                clearable
                                width="150px"
                                @visible-change="changeSelect('ships',item.id)"
                            >
                                <el-option
                                    v-for="ship in shipsTemplate[item.id]"
                                    :key="ship.templateId"
                                    :label="ship.name"
                                    style="width: 150px;"
                                    :title="ship.name"
                                    :value="ship.templateId">
                                </el-option>
                            </el-select>
                            <!-- <div><el-link class="no-border" @click="refreshTemplate(item.id, item.userId)">刷新模板</el-link></div> -->
                        </div>
                    </div>
                    <span v-else class="no-shops">暂无平台店铺</span>
                </el-form-item>
                <el-form-item label="运费模版:" prop="templateList" label-width="120px">
                    <div class="ship-wrp" v-if="shopList.length > 0">
                        <div class="item" v-for="(item, idx) in shopList" :key="idx">
                            <div class="shopname">
                                <img class="shop-img" :src="item.icon"/>
                                <el-tooltip v-if="item.channelIcon" :content="item.channelName" style="margin: 0px -6px 0px 6px;">
                                    <el-image :src="item.channelIcon" style="width: 18px; height: 18px;overflow: unset;top: 4px;"></el-image>
                                </el-tooltip>
                                <span>{{ item.shortTitle || item.title }}</span>
                            </div>
                            <el-select 
                                :loading="selectLoading" 
                                v-model="carriageValue[item.id]" 
                                placeholder="请选择运费模板" 
                                clearable
                                width="150px"
                                @visible-change="changeSelect('carriage',item.id)"
                            >
                                <el-option
                                    v-for="temp in carriageTemplate[item.id]"
                                    :key="temp.templateId"
                                    :label="temp.name"
                                    style="width: 150px;"
                                    :title="temp.name"
                                    :value="temp.templateId">
                                </el-option>
                            </el-select>
                            <!-- <div><el-link class="no-border" @click="refreshTemplate(item.id, item.userId)">刷新模板</el-link></div> -->
                        </div>
                    </div>
                    <span v-else class="no-shops">暂无平台店铺</span>
                </el-form-item>
            </div>
          </section>
          <PriceConf ref="PriceConfRef" platform="xhs" :priceList="value.price" :shopPriceConf="value.shopPriceConf"></PriceConf>
          <div class="btns">
            <el-button type="primary" @click="save">保存模板</el-button>
            <el-button @click="back">返回</el-button>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import '@/assets/css/prod.scss';
import { getDistributionConfig, updateDistributionConfig } from '@servers/prod/conf/index.js';
import { getShopList } from '@servers/base/shop/index.js';
import { getXhsCarriageTemplateList,logisticsList } from '@/servers/prod/center/xhs.js';
import PriceConf from './components/PriceConf.vue';
import BrandSettingConfig from './components/BrandSettingConfig/index.vue';
import BrandSettingOtherConfig from './components/BrandSettingOtherConfig/index.vue';
import { cloneDeep } from 'lodash';

const PLATFORMID = 'xhs';

export default {
  name: 'XhsConf',
  provide() {
    return {
        platform:'xhs',
    }
  },
  props: {
    back: Function,
  },
  components: {
      PriceConf,
      BrandSettingConfig,
      BrandSettingOtherConfig,
  },
  data() {
    return {
      value: {
        shelfState:2,
        outerType: 2,
        shipSet:[],
        autoCropImageConfigList:[],
        logisticsList:[], // 物流模版
        templateList:[], // 运费模版
      },
      rules: {
        shelfState: [{ required: true, message: '' }],
      },
      selectLoading: false,
      shopList:[],
      shipsValue: {// 物流模板
      },
      carriageValue: {// 运费模板
      },
      carriageTemplate: { // 运费模板列表

      },
      shipsTemplate:{ // 物流模板列表

      },
      categoryBrandRelationsList:[],
      brandConfList: [],
    };
  },
  computed:{
    dataSourceCategory: {
      get(){
        if (!this.categoryBrandRelationsList?.length) {
          return [];
        }
        return this.categoryBrandRelationsList.flatMap(item =>
          item.relations.map(childRelation => ({
            ...childRelation,
            previewCategoryId: childRelation.categoryId,
            parent: { shopId: item.shopId }
          }))
        );
      },
      set(next){
        const grouped = {};
        (next || []).forEach(row => {
          const shopId = row?.parent?.shopId;
          if(!shopId) return;
          if(!grouped[shopId]) grouped[shopId] = [];
          const copy = { ...row };
          delete copy.parent;
          delete copy.previewCategoryId;
          grouped[shopId].push(copy);
        });
        this.categoryBrandRelationsList = Object.keys(grouped).map(shopId => ({
          shopId: isNaN(Number(shopId)) ? shopId : Number(shopId),
          shopType: PLATFORMID,
          relations: grouped[shopId]
        }));
      }
    }
  },
  mounted() {
    this.getConf();
  },
  methods: {
    async getConf() {
      try {
        const res = await getDistributionConfig({ shopType: PLATFORMID });
        this.shopList = this.$store.getters.get_AllShops_BySource('xhs') || [];
        const parseArr = v => {
          if (Array.isArray(v)) return v;
          if (typeof v === 'string' && v.trim()) {
            try { return JSON.parse(v); } catch (e) { return []; }
          }
          return [];
        };
        Object.assign(this.value, {
          shelfState: res.shelfState || 2,
          outerType: res.outerType || 2,
          price: parseArr(res.price || []),
          shopPriceConf: parseArr(res.shopPriceConf || []),
          autoCropImageConfigList: res.autoCropImageConfigList || [],
        });
        this.initTemplate(res.logisticsList || []);
        this.initCarriageTemplate(res.templateList || []);
        this.categoryBrandRelationsList = res.categoryBrandRelations || [];
        this.handleUniqData(res.brandConfList || []);
      } catch (e) {
        console.error(e);
        this.$message.error('配置加载失败，请重试');
      }
    },
    async getShopList() {
      const res = await getShopList({
        source: 'xhs',
        pageNo: 1,
        pageSize: 300,
      });
      return res.list || [];
    },
    // 获取运费模版
    async getCarriageTemplateList(shopId){
        const data = await getXhsCarriageTemplateList({ shopId });
        let carriageTemplateList = data?.carriageTemplateList || [];
        if (!carriageTemplateList.length) return;
        const list = carriageTemplateList.map(item => {
          return {
            shopId,
            templateId: item.templateId,
            name: item.templateName,
          };
        });
        this.$set(this.carriageTemplate, shopId, list);
    },
    // 获取物流模版
    async getLogisticsList(shopId){
        let data = await logisticsList(shopId);
        if(data.result == 1){
          let logisticsPlans = data.data?.logisticsPlans || [];
          const list = logisticsPlans.map(item => {
            return {
              shopId,
              templateId: item.planInfoId,
              name: item.planInfoName,
            };
          });
          this.$set(this.shipsTemplate, shopId, list);
        }
    },
    save() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          const { shelfState, outerType, autoCropImageConfigList } = this.value;
          let [commConf,shopConf] = this.$refs.PriceConfRef.getData();
          const templateList = []; // 运费模版
          const logisticsList = []; // 物流模版
          Object.keys(this.shipsValue).forEach(id => {
              const name = this.findTemplateName('ship',id, this.shipsValue[id]);
                  const channel = this.shopList.find(shop => shop.id == id)?.channel
                  logisticsList.push({
                      shopId: id, // id 不是 userId
                      templateId: this.shipsValue[id] || null,
                      templateName: name || null,
                      channel
                  });
          })
          Object.keys(this.carriageValue).forEach(id => {
              const name = this.findTemplateName('carriage',id, this.carriageValue[id]);
              const channel = this.shopList.find(shop => shop.id == id)?.channel
              templateList.push({
                  shopId: id, // id 不是 userId
                  templateId: this.carriageValue[id] || null,
                  templateName: name || null,
                  channel
              });
          })
          const res = await updateDistributionConfig({
            shopType: PLATFORMID,
            shelfState,
            outerType,
            autoCropImageConfigList,
            logisticsList, // 物流模版
            templateList, // 运费模版
            price: JSON.stringify(commConf),
            shopPriceConf:JSON.stringify(shopConf),
            categoryBrandRelations: this.categoryBrandRelationsList,
            brandConfList: this.brandConfList,
          });
          if (res) {
            this.$message.success('保存成功');
          }
        }
      });
    },
    initTemplate(templateList=[]) {
        const ships = {};
        const shopUserIdMap = {};
        for(let shop of this.shopList) {
            ships[shop.id] = '';
            shopUserIdMap[shop.userId] = shop.id;
        }
        if (this.shopList.length && templateList) {
            templateList.forEach(item => {
                item.shopId = shopUserIdMap[item.shopId] || item.shopId;
                this.$set(this.shipsValue, item.shopId, item.templateId);
                if(item.templateId && item.templateName){
                  this.$set(this.shipsTemplate, item.shopId, [{shopId:item.shopId,templateId:item.templateId,name:item.templateName}]);
                }
            })
        }
    },
    initCarriageTemplate(templateList=[]) {
        const ships = {};
        const shopUserIdMap = {};
        for(let shop of this.shopList) {
            ships[shop.id] = '';
            shopUserIdMap[shop.userId] = shop.id;
        }
        if (this.shopList.length && templateList) {
            templateList.forEach(item => {
                item.shopId = shopUserIdMap[item.shopId] || item.shopId;
                ships[item.shopId] = item.templateId;
                this.$set(this.carriageValue, item.shopId, item.templateId);
                if(item.templateId && item.templateName){
                  this.$set(this.carriageTemplate, item.shopId, [{shopId:item.shopId,templateId:item.templateId,name:item.templateName}]);
                }
            })
        }
    },
    async changeSelect(type,shopId) {
        if(type === 'ships'){
          if(!this.shipsTemplate[shopId] || !this.shipsTemplate[shopId].length ||
          (this.shipsTemplate[shopId].length === 1 && this.shipsTemplate[shopId][0].templateId === this.shipsValue[shopId])){
              this.getLogisticsList(shopId);
          }
        }else if(type === 'carriage'){
          if(!this.carriageTemplate[shopId] || !this.carriageTemplate[shopId].length ||
          (this.carriageTemplate[shopId].length === 1 && this.carriageTemplate[shopId][0].templateId === this.carriageValue[shopId])){
              this.getCarriageTemplateList(shopId);
          }
        }
    },
    findTemplateName(type,shopid, tempId) {
        if(type == 'carriage'){
          const template = this.carriageTemplate[shopid]?.find(item => item.templateId === tempId);
          return template?.name || '';
        }else if(type == 'ship'){
          const template = this.shipsTemplate[shopid]?.find(item => item.templateId === tempId);
          return template?.name || '';
        }
    },
    handleUniqData(value){
        const list = cloneDeep(value)
        const data = list.map((item,index)=>{
            item.id = index + '_' + item.shopIds.join('')
            return item
        })
        this.brandConfList = data
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
